import {XauditModel} from '../xaudit.model';

export class PatientInsuranceCoverageDataModel extends XauditModel {
  CoverageID: string;
  InsuranceID: string;
  Code: string;
  enumFeeItemCategoryId: string;
  CoveragePCT: number;
  CoverageAmount: number;
  enumFeeCoverageCalcTypeId: string;
  isInclusive : boolean;
  isNotCovered: boolean;
}
